import React from "react";

const JQuery_Get_Post = () => {
  return (
    <div>
      <h1>JQuery_Get_Post</h1>
      <p>Placeholder component for: "JQuery_Get_Post"</p>
    </div>
  );
};

export default JQuery_Get_Post;
